module.exports = __webpack_public_path__ + "img/children-f2.d5d0ac7c.png";